module.exports = __webpack_public_path__ + "static/media/financingIco_Selected.c899519b.svg";